import React, { useState, useEffect } from 'react';
import { Layout, Menu, Badge } from 'antd';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  ShoppingCartOutlined,
  TagsOutlined,
  FileOutlined,
  LogoutOutlined,
  ScanOutlined,
  ImportOutlined,
  ExceptionOutlined,
  GlobalOutlined,
  KeyOutlined,
} from '@ant-design/icons';
import Logo from '../Logo';
import Version from '../Version';
import { logout } from '../../utils/auth';

const { Content, Sider } = Layout;

const StaffLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [exceptionCount, setExceptionCount] = useState(0);

  useEffect(() => {
    const fetchExceptionCount = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('/api/orders/count?status=异常件', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        const data = await response.json();
        setExceptionCount(data.count);
      } catch (error) {
        console.error('Failed to fetch exception count:', error);
      }
    };

    fetchExceptionCount();
    // Refresh count every minute
    const interval = setInterval(fetchExceptionCount, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'airwaybills',
      icon: <FileOutlined />,
      label: '空运单管理',
      onClick: () => navigate('/staff/airwaybills')
    },
    {
      key: 'batches',
      icon: <TagsOutlined />,
      label: '批次管理',
      onClick: () => navigate('/staff/batches')
    },
    {
      key: 'import',
      icon: <ImportOutlined />,
      label: '订单导入',
      onClick: () => navigate('/staff/import')
    },
    {
      key: 'orders',
      icon: <ShoppingCartOutlined />,
      label: '订单管理',
      onClick: () => navigate('/staff/orders')
    },
    {
      key: 'exception',
      icon: <ExceptionOutlined />,
      label: (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          异常件
          {exceptionCount > 0 && (
            <Badge 
              count={exceptionCount}
              style={{ 
                marginLeft: 8,
                backgroundColor: '#ff4d4f',
                boxShadow: 'none'
              }}
            />
          )}
        </span>
      ),
      onClick: () => navigate('/staff/exception')
    },
    {
      key: 'scan-print',
      icon: <ScanOutlined />,
      label: '扫描打印',
      onClick: () => navigate('/staff/scan-print')
    },
    {
      key: 'tracking',
      icon: <GlobalOutlined />,
      label: '包裹跟踪',
      onClick: () => navigate('/staff/tracking')
    },
    {
      key: 'change-password',
      icon: <KeyOutlined />,
      label: '更改密码',
      onClick: () => navigate('/staff/change-password')
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    }
  ];

  // Get the current selected key from the path
  const selectedKey = location.pathname.split('/')[2] || 'orders';

  return (
    <Layout style={{ minHeight: '100vh', background: '#fff' }}>
      <Sider 
        width={200} 
        theme="light"
        style={{
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Logo />
        </div>
        <Version />
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{ flex: 1, borderRight: 0 }}
          items={menuItems}
        />
      </Sider>
      <Layout style={{ marginLeft: 200, background: '#fff', minHeight: '100vh' }}>
        <Content style={{ margin: '10px' }}>
          <div style={{ padding: '2px 10px', minHeight: 280 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default StaffLayout;
